import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";
import SidebarNavMenu from "../../components/SidebarNavMenu";

import {ReactComponent as PeopleIcon} from "assets/img/people.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function MerchandisingItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    const hasMemberManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.GLOBAL_MEMBER_MANAGEMENT);
    const hasRoleManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.GLOBAL_ROLE_MANAGEMENT);

    if (!hasMemberManagementAuthorization && !hasRoleManagementAuthorization) {
        return null;
    }

    return (
        <SidebarNavMenu
            icon={<PeopleIcon />}
            content={<FormattedMessage id='sidebar.item.team' />}
        >
            {hasMemberManagementAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.MEMBERS_LIST}
                    selected={currentPath.startsWith(MarketplaceRoutes.MEMBERS)}
                >
                    <FormattedMessage id={'sidebar.item.members'} />
                </SidebarItem>
            )}
            {hasRoleManagementAuthorization && (
                <SidebarItem
                    to={MarketplaceRoutes.ROLE_LIST}
                    selected={currentPath.startsWith(MarketplaceRoutes.ROLES)}
                >
                    <FormattedMessage id={'sidebar.item.roles'} />
                </SidebarItem>
            )}
        </SidebarNavMenu>
    );
}

export default MerchandisingItem;
